import {apiFetch, apiFetchBlob} from "../client";
import type {ChatMessage, ChatPage} from "../orderChat";
import {saveChatFile, sendChatMessageTo} from "../orderChat";

export interface AdminChat {
    order_id: string;
    remote_id: string;
    order_status: string;
    workflow_kind: string;
    trader_id: string | null;
    trader_name: string;
    owner_available: boolean;
    last_message_at: string;
    last_text: string;
    last_file_name: string;
    last_sender: "client" | "trader" | "admin";
}
export interface AdminChatPage {items: AdminChat[]; next_cursor: string; enabled: boolean;}
export interface AdminChatFilters {state: "all" | "active" | "completed"; owner: "all" | "unassigned"; search: string;}

export function adminChats(token: string, filters: AdminChatFilters, cursor = "", signal?: AbortSignal): Promise<AdminChatPage> {
    const query = new URLSearchParams({...filters, cursor});
    return apiFetch(`/admin/order-chats?${query}`, token, {signal});
}
const chatPath = (id: string): string => `/admin/order-chats/${encodeURIComponent(id)}`;
export function adminChatMessages(token: string, orderID: string, before?: number): Promise<ChatPage> {
    return apiFetch(`${chatPath(orderID)}/messages${before ? `?before=${before}` : ""}`, token);
}
export async function downloadAdminChatFile(token: string, orderID: string, message: ChatMessage): Promise<void> {
    const blob = await apiFetchBlob(`${chatPath(orderID)}/messages/${encodeURIComponent(message.id)}/file`, token);
    saveChatFile(blob, message.file?.name || "file");
}

export function sendAdminChatMessage(token: string, orderID: string, key: string, text: string, file: File | null): Promise<ChatMessage> {
    return sendChatMessageTo(`${chatPath(orderID)}/messages`, token, key, text, file);
}
export function retryAdminChatMessage(token: string, orderID: string, messageID: string): Promise<void> {
    return apiFetch(`${chatPath(orderID)}/messages/${encodeURIComponent(messageID)}/retry`, token, {method: "POST"});
}
